import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

// Entrance
import Enterphone from "../Entrance/EnterPhone";
import Enterverfcode from "../Entrance/Enterverfcode";
import Personalinfo from "../Entrance/personalinfo";
import Shopinfo from "../Entrance/Shopinfo";
import Addshop from "../Entrance/Addshop";
import Confim from "../Entrance/Confirminfo";

// Education
import Homepage from "../Education/Homepage";
import Category from "../Education/Category";
import Content from "../Education/content";
import Coursecnt from "../Education/Coursecontent";
import CoursePdf from "../Education/CoursePdf";
import Mycourses from "../Education/Mycourses";
import Exam from "../Education/Exam/Exam";
import ResultExam from "../Education/Exam/resultExam";

// Award
import Award from "../Award/Award";

// MainPage
import MainPage from "../MainPage/MainPage";

// News
import News from "../News/News";
import Innernews from "../News/Innernews";

// Comments
import Comments from "../Comments/Comments";

// Notification
import Notification from "../Notifications/notification";

// Profile
import Profile from "../Profile/Profile";
import MyLottery from "../Profile/lottery/myLattery";
import LotteryExpire from "../Profile/lottery/lotteryExpire";
import LotteryDetailes from "../Profile/lottery/lotteryDetails";
// Profile => MyWebinars
import MyWebinars from "../Profile/webinars/myWebinars";
import WebinarDetailes from "../Profile/webinars/webinarDetailes";
// Profile => MyScore
import MyScore from "../Profile/score/myScore";
import MyScoreDetails from "../Profile/score/myScoreDetails";
// Profile => tickets
import TicketList from "../Profile/tickets/list-tickets/listTickets";
import Ticket from "../Profile/tickets/inner-page/ticket";
import CreateTicket from "../Profile/tickets/create-tiket/createTicket";
import ReplayTicket from "../Profile/tickets/replay-ticket/replayTicket";
// Profile => search
import Search from "../search/search";
// Profile => myCourses
import MyCourses from "../Profile/myCourses/myCourses";
// Profile => MyLicenses
import MyLicenses from "../Profile/myLicenses/myLicenses";
// Profile => edite-account
import AccountType from "../Profile/myAccount/accountType";
import EditPersonalInfo from "../Profile/myAccount/editPersonalInfo/editPersonalInfo";
import EditShopInfo from "../Profile/myAccount/editShopInfo/editShopInfo";
// SuggestionCourse
import SuggestionCourse from "../suggestionCourse/suggestionCourse";
// notification config
import NotificationConfig from "./Notification.config";
import MaintenanceMode from "../MaintenanceMode";
import ExamList from "../Exams/ExamList";

import { base_url } from "../Api/Api";
import EndedExam from "../Education/Exam/EndedExam";

const Routes = () => {
  const [maintenance, setMaintenance] = useState({
    active: 0,
    text: "از اختلال پیش آمده متاسفیم ",
  });
  useEffect(() => {
    
        base_url.get("https://s-plus.ir/api/splash").then((res) => {
        const { maintenanceMode, maintenanceText } = res.data;
        setMaintenance({
          active: maintenanceMode,
          text: maintenanceText,
        });
      });
  },[]);
  NotificationConfig();

  return maintenance.active == 1 ? (
    <MaintenanceMode text={maintenance.text} />
  ) : (
    <Router>
      {/* entrance */}
      <Route
        exact
        path="/Entrance"
        component={
          localStorage.getItem("logined") != null ? MainPage : Enterphone
        }
      ></Route>
      <Route
        exact
        path="/Entrance/step2"
        component={
          localStorage.getItem("logined") != null ? MainPage : Enterverfcode
        }
      ></Route>
      <Route
        exact
        path="/Entrance/step3"
        component={
          localStorage.getItem("logined") != null ? MainPage : Personalinfo
        }
      ></Route>
      <Route
        exact
        path="/Entrance/step4"
        component={
          localStorage.getItem("logined") != null ? MainPage : Shopinfo
        }
      ></Route>
      <Route
        exact
        path="/Entrance/step5"
        component={localStorage.getItem("logined") != null ? MainPage : Addshop}
      ></Route>
      <Route
        exact
        path="/Entrance/step6"
        component={localStorage.getItem("logined") != null ? MainPage : Confim}
      ></Route>
      {/* Education */}
      <Route
        exact
        path="/Education"
        component={
          localStorage.getItem("logined") == null ? Enterphone : Homepage
        }
      ></Route>
      <Route
        exact
        path="/Education/category/:pg?"
        component={
          localStorage.getItem("logined") == null ? Enterphone : Category
        }
      ></Route>
      <Route
        exact
        path="/Education/content/:id?/:isHome?"
        component={
          localStorage.getItem("logined") == null ? Enterphone : Content
        }
      ></Route>
      <Route
        exact
        path="/Education/course-content/:id?"
        component={
          localStorage.getItem("logined") == null ? Enterphone : Coursecnt
        }
      ></Route>
      <Route
        exact
        path="/Education/course-content/:id?/pdf"
        component={
          localStorage.getItem("logined") == null ? Enterphone : CoursePdf
        }
      ></Route>
      <Route
        exact
        path="/Education/mycourses/:id?"
        component={
          localStorage.getItem("logined") == null ? Enterphone : Mycourses
        }
      ></Route>
      {/* Quiz */}
        <Route
          exact
          path="/Education/Quiz/:coursId?/:id?"
          component={localStorage.getItem("logined") == null ? Enterphone : Exam}
        ></Route>
        <Route
          exact
          path="/Education/EndedExam/:coursId"
          component={localStorage.getItem("logined") == null ? Enterphone : EndedExam}
        ></Route>
      <Route
        exact
        path="/Education/Quiz-result/:id?"
        component={
          localStorage.getItem("logined") == null ? Enterphone : ResultExam
        }
      ></Route>
      {/* Award */}
      <Route
        exact
        path="/Award"
        component={localStorage.getItem("logined") == null ? Enterphone : Award}
      ></Route>
      {/* MainPage */}
      <Route
        exact
        path="/"
        component={
          localStorage.getItem("logined") == null ? Enterphone : MainPage
        }
      ></Route>
      {/* <Route exact path="/MainPage" component={MainPage} ></Route> */}
      {/* News */}
      <Route
        exact
        path="/News"
        component={localStorage.getItem("logined") == null ? Enterphone : News}
      ></Route>
      <Route
        exact
        path="/News/inner-page/:id?"
        component={
          localStorage.getItem("logined") == null ? Enterphone : Innernews
        }
      ></Route>
      {/* comments */}
      <Route
        exact
        path="/Comments/:id?"
        component={
          localStorage.getItem("logined") == null ? Enterphone : Comments
        }
      ></Route>
      {/* Lottery */}
      <Route
        exact
        path="/lottery"
        component={
          localStorage.getItem("logined") == null ? Enterphone : MyLottery
        }
      ></Route>
      <Route
        exact
        path="/lottery/expired/:id?"
        component={
          localStorage.getItem("logined") == null ? Enterphone : LotteryExpire
        }
      ></Route>
      <Route
        exact
        path="/lottery/details/:id?"
        component={
          localStorage.getItem("logined") == null ? Enterphone : LotteryDetailes
        }
      ></Route>
      {/* Profile */}
      <Route
        exact
        path="/Profile"
        component={
          localStorage.getItem("logined") == null ? Enterphone : Profile
        }
      ></Route>
      {/* My-Webinars */}
      <Route
        exact
        path="/myWebinars"
        component={
          localStorage.getItem("logined") == null ? Enterphone : MyWebinars
        }
      ></Route>
      <Route
        exact
        path="/myWebinars/detailes/:id?"
        component={
          localStorage.getItem("logined") == null ? Enterphone : WebinarDetailes
        }
      ></Route>
      {/* My-score */}
      <Route
        exact
        path="/myScore"
        component={
          localStorage.getItem("logined") == null ? Enterphone : MyScore
        }
      ></Route>
      <Route
        exact
        path="/myScore/detailes"
        component={
          localStorage.getItem("logined") == null ? Enterphone : MyScoreDetails
        }
      ></Route>
      {/* tickets */}
      <Route
        exact
        path="/tickets"
        component={
          localStorage.getItem("logined") == null ? Enterphone : TicketList
        }
      ></Route>
      <Route
        exact
        path="/tickets/inner-page/:id?"
        component={
          localStorage.getItem("logined") == null ? Enterphone : Ticket
        }
      ></Route>
      <Route
        exact
        path="/tickets/replay-ticket/:id?"
        component={
          localStorage.getItem("logined") == null ? Enterphone : ReplayTicket
        }
      ></Route>
      <Route
        exact
        path="/tickets/create-ticket"
        component={
          localStorage.getItem("logined") == null ? Enterphone : CreateTicket
        }
      ></Route>
      {/* search */}
      <Route
        exact
        path="/search"
        component={
          localStorage.getItem("logined") == null ? Enterphone : Search
        }
      ></Route>
      {/* myCourses */}
      <Route
        exact
        path="/myCourses"
        component={
          localStorage.getItem("logined") == null ? Enterphone : MyCourses
        }
      ></Route>
      {/* MyLicenses */}
      <Route
        exact
        path="/myLicenses"
        component={
          localStorage.getItem("logined") == null ? Enterphone : MyLicenses
        }
      ></Route>
      {/* AccountType*/}
      <Route
        exact
        path="/myAccount"
        component={
          localStorage.getItem("logined") == null ? Enterphone : AccountType
        }
      ></Route>
      <Route
        exact
        path="/myAccount/personalInfo"
        component={
          localStorage.getItem("logined") == null
            ? Enterphone
            : EditPersonalInfo
        }
      ></Route>
      <Route
        exact
        path="/myAccount/shopInfo"
        component={
          localStorage.getItem("logined") == null ? Enterphone : EditShopInfo
        }
      ></Route>
      {/* Notification*/}
      <Route
        exact
        path="/notifications"
        component={
          localStorage.getItem("logined") == null ? Enterphone : Notification
        }
      ></Route>
      {/* Notification*/}
      <Route
        exact
        path="/suggestionCourse"
        component={
          localStorage.getItem("logined") == null
            ? Enterphone
            : SuggestionCourse
        }
      ></Route>
      {/* Exams */}
      <Route
        exact
        path="/myExams"
        component={
          localStorage.getItem("logined") == null ? Enterphone : ExamList
        }
      ></Route>
    </Router>
  );
};

export default Routes;
